export default [
	{
		path: '/LCJoinAssistant',
		name: 'LCJoinAssistant',
		component: () => import(/* LCJoinAssistant */ './index.vue'),
		meta: {
			title: '',
			// keepAlive: true  //是否设置为缓存数据页面
		},
		children: [
			{
				path: 'index/:id?',
				name: 'LCJoinAssistant_index',
				component: () => import(/* LCJoinAssistant_index */ './pages/pay/web/index.vue'),
				meta: {
					title: '',
					// keepAlive: true  //是否设置为缓存数据页面
				},
			}
		]
	},
	{
		path: '/LCWXJoinAssistant',
		name: 'LCWXJoinAssistant',
		component: () => import(/* LCWXJoinAssistant */ './index.vue'),
		meta: {
			title: '',
			// keepAlive: true  //是否设置为缓存数据页面
		},
		children: [
			{
				path: 'index/:id?',
				name: 'LCWXJoinAssistant_index',
				component: () => import(/* LCWXJoinAssistant_index */ './pages/pay/wx/index.vue'),
				meta: {
					title: '',
					auth: true, // 如果此路由需要微信授权请设置为true,默认为false
					// keepAlive: true  //是否设置为缓存数据页面
				}
			},
			{
				path: 'success',
				name: 'LCWXJoinAssistant_success',
				component: () => import(/* LCWXJoinAssistant_success */ './pages/pay/wx/success.vue'),
				meta: {
					title: '',
					auth: false, // 如果此路由需要微信授权请设置为true,默认为false
					// keepAlive: true  //是否设置为缓存数据页面
				}
			}
		]
	},
	{
		path: '/LCBlankJoinAssistant',
		name: 'LCBlankJoinAssistant',
		component: () => import(/* LCBlankJoinAssistant */ './index.vue'),
		meta: {
			title: '',
			// keepAlive: true  //是否设置为缓存数据页面
		},
		children: [
			{
				path: 'index',
				name: 'LCBlankJoinAssistant_index',
				component: () => import(/* LCBlankJoinAssistant_index */ './pages/pay/blank/index.vue'),
				meta: {
					title: '',
					// keepAlive: true  //是否设置为缓存数据页面
				},
			}
		]
	},
	{
		path: '/LCFreeJoinAssistant',
		name: 'LCFreeJoinAssistant',
		component: () => import(/* LCFreeJoinAssistant */ './index.vue'),
		meta: {
			title: '',
			// keepAlive: true  //是否设置为缓存数据页面
		},
		children: [
			{
				path: 'index/:id?',
				name: 'LCFreeJoinAssistant_index',
				component: () => import(/* LCFreeJoinAssistant_index */ './pages/free/web/index.vue'),
				meta: {
					title: '',
					// keepAlive: true  //是否设置为缓存数据页面
				},
			},
			{
				path: 'indexQuestion/:id?',
				name: 'LCFreeJoinAssistant_indexQuestion',
				component: () => import(/* LCFreeJoinAssistant_indexQuestion */ './pages/free/web/indexQuestion.vue'),
				meta: {
					title: '',
					// keepAlive: true  //是否设置为缓存数据页面
				},
			}
		]
	}
]
